import {
  Button,
  Divider,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  IconButton,
  Tooltip,
  HStack,
  Box,
  ModalCloseButton,
  Spinner,
  Center,
  ButtonGroup,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaFolder, FaFolderPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchFolders } from "../../_actions/folderActions";

import { ShowNoContent } from "../common/statelessView";
import { MoveFolderSlide } from "../styled/home/stylesHome";

const TldrMoveToFolderModal = (props) => {
  const { t } = useTranslation(["folders"]);
  const signal = axios.CancelToken.source();
  const {
    show,
    onHide,
    inProgress,
    onYes,
    currentFolderId = undefined,
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const folders = useSelector((state) => state.folders.folders);
  const dispatch = useDispatch();

  useEffect(() => {
    if (folders.length === 0) {
      fetchMyFolders();
    }

    return () => {
      setSelectedIndex(0);
    };
  }, []);

  const filteredFolders = folders.filter((f) => f.id !== currentFolderId);

  function fetchMyFolders() {
    setLoading(true);
    const payload = {
      searchTerm: "",
      props: {
        folders,
        ...props,
      },
      updateRecent: false,
    };

    dispatch(fetchFolders(payload, signal.token)).then(() => {
      setLoading(false);
    });
  }

  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("add_to_folder")}</ModalHeader>
        <Divider my="1" />
        <ModalCloseButton />
        <ModalBody>
          <MoveFolderSlide>
            {loading ? (
              <Center h="100%" w="100%">
                <Spinner color="brand.primary" size="lg" />
              </Center>
            ) : !loading && filteredFolders.length === 0 ? (
              <Center h="100%" w="100%">
                <ShowNoContent text={t("no_folders")} />
              </Center>
            ) : (
              filteredFolders.map((item, index) => (
                <div
                  className={`move-folder-item ${
                    index === selectedIndex ? "selected" : ""
                  }`}
                  onClick={() => setSelectedIndex(index)}
                  onDoubleClick={() => {
                    onYes(
                      filteredFolders[index].id,
                      filteredFolders[index].name
                    );
                  }}
                  key={index}
                >
                  <Icon as={FaFolder} mr={3} />
                  <span className="name">{item.name}</span>
                </div>
              ))
            )}
          </MoveFolderSlide>
        </ModalBody>
        <Divider my="1" />

        <ModalFooter>
          <HStack justify="space-between" w="100%">
            <Box>
              <Tooltip label={t("new_folder")} hasArrow>
                <IconButton
                  icon={<Icon as={FaFolderPlus} />}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onAddFolder();
                  }}
                  variant="secondary"
                />
              </Tooltip>
            </Box>
            <Box>
              <ButtonGroup>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    onHide();
                  }}
                  variant="outline"
                  disabled={inProgress}
                >
                  {t("cancel", { ns: "common" })}
                </Button>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    onYes(
                      filteredFolders[selectedIndex].id,
                      filteredFolders[selectedIndex].name
                    );
                  }}
                  variant="solid"
                  disabled={filteredFolders.length === 0 || inProgress}
                  isLoading={inProgress}
                >
                  {t("move_to_folder.action")}
                </Button>
              </ButtonGroup>
            </Box>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TldrMoveToFolderModal;
